import React from "react";
import { connect } from "react-redux";
import Graph from "./../GraphContainer";
import PeriodDatesPickerContainer from "./../PeriodDatesPickerContainer";
import Z3 from "./../Z3Container";
import Z4 from "./../Z4Container";
import Z5 from "./../Z5Container";
import KpiIndicator from "./../KpiIndicatorContainer";
import Periods from "./../PeriodsContainer";

const PerformanceContainer = props => {
  return (
    <div className="p-stats">
      <div className="p-stats-content p-al-full p-al-wrap">
        <div className="p-w-4-5 p-stats-container">
          {/*Content top menu*/}
          <div className="p-al-full">
            <div className="p-stats-indicator p-w-1-3 p-content-item p-mrg-bot-s p-al-r-center">
              <KpiIndicator />
            </div>
            <div className="p-w-2-3 p-content-item p-mrg-bot-s p-al-r-center p-al-wrap">
              <div className="p-stats-indicator-period p-w-1-2 p-mrg-right-s">
                <div className="p-page-subtitle p-stats-indicator-label p-mrg-bot-s">Période</div>
                <PeriodDatesPickerContainer />
              </div>
              <div className="p-stats-indicator-period p-w-1-3">
                <div className="p-page-subtitle p-stats-indicator-label p-mrg-bot-s">Périodes commerciales</div>
                <Periods />
                {/*<PeriodComRangePickerContainer disabled={true}/>*/}
              </div>
            </div>
          </div>
          {/*Content grid container*/}
          <div className="p-content-item">
            <Z3 />
            <div>
              <Graph />
            </div>
          </div>
        </div>
        {/*Filters (side)*/}
        <div className="p-w-1-5 p-content-item p-stats-filters">
          <Z4 />
          <Z5 />
        </div>
      </div>
    </div>
  );
};

//REDUX
const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(PerformanceContainer);



// WEBPACK FOOTER //
// src/modules/stats/containers/views/PerformanceContainer.js